// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as historyActionCreators from '../../actions/history';
import useMergeProps from '../../hooks/useMergeProps';

import HistoryPagination from './HistoryPagination';
import selectHistoryPaginationProps from './HistoryPagination.selector';

const HistoryPaginationContainer = () => {
  const dispatch = useDispatch();
  const selectedProps = useSelector(selectHistoryPaginationProps);

  const setPage = useCallback(
    (index) => {
      dispatch(historyActionCreators.setPage(index));
    },
    [dispatch],
  );

  const nextPage = useCallback(() => {
    dispatch(historyActionCreators.nextPage());
  }, [dispatch]);

  const prevPage = useCallback(() => {
    dispatch(historyActionCreators.prevPage());
  }, [dispatch]);

  const otherProps = useMemo(() => ({ setPage, nextPage, prevPage }), [setPage, nextPage, prevPage]);

  const enhancedProps = useMergeProps({ selectedProps, otherProps });

  return <HistoryPagination {...enhancedProps} />;
};

export default HistoryPaginationContainer;
